import { Dayjs } from "dayjs";
import { Image as AntImage, Row, Col, Button, Image } from "antd";
import { FileImageOutlined } from "@ant-design/icons";
import numeral from "numeral";
import useModal from "antd/es/modal/useModal";
import { useMemo } from "react";
import Slider from "react-slick";

import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";

type AuditFormProps = {
  car: {
    bookingTimes: Dayjs[];
    id: number;
    title: string;
    imageUrl: CarImageProps[];
    brand: string;
    modal: string;
    price: number;
    type: string;
    years: number;
    coordinatorName?: string;
    createdAt: number;
    location?: string;
    merchantId: number;
    name: string;
    phone: string;
    salerId?: string;
    status: "PENDING" | "CONCATED" | "DONE";
    viewingType: "ONLINE" | "OFFLINE";

    color: string;
    basePrice: number;
    customerName: string;
    customerEmail: string;
    customerPhone: string;
    travelLicenseImageUrl: string;
    appraisalImageUrl?: string;
  };
};

export function AuditForm(props: AuditFormProps) {
  const [modal, contextHolder] = useModal();

  const showModalImage = ({ title, url = "" }: { title: string; url?: string }) => {
    if (url.substring(url.length - 4) === ".pdf") {
      window.open(url);
    } else {
      return modal.info({
        width: 800,
        title,
        content: <AntImage className="w-full mb-2" style={{ aspectRatio: "1 / 1", objectFit: "cover" }} src={url} />,
        icon: null,
        okText: "關閉",
      });
    }
  };

  return (
    <Row className="w-full" gutter={15}>
      {contextHolder}

      <Col span={24}>
        <CustomSlider images={props.car?.imageUrl} />

        <div>
          <span className="text-m font-bold">標題：</span>
          {props.car?.title}
        </div>
        <div>
          <span className="text-m font-bold">車廠：</span>
          {props.car?.brand}
        </div>
        <div>
          <span className="text-m font-bold">車款：</span>
          {props.car?.type}
        </div>
        <div>
          <span className="text-m font-bold">車色：</span>
          {props.car?.color}
        </div>
        {/* <div>
          <span className="text-m font-bold">車種：</span>
          {props.car?.modal}
        </div> */}
        <div>
          <span className="text-m font-bold">底價：</span>
          {numeral(props.car?.basePrice).format("$0,0")}
        </div>
        <div>
          <span className="text-m font-bold">價錢：</span>
          {numeral(props.car?.price).format("$0,0")}
        </div>
        <div>
          <span className="text-m font-bold">出廠年份：</span>
          {props.car?.years}
        </div>
        <div>
          <span className="text-m font-bold">行照：</span>
          {props.car?.travelLicenseImageUrl ? (
            <Button
              type="primary"
              shape="circle"
              icon={<FileImageOutlined />}
              onClick={() => showModalImage({ title: "行照", url: props.car?.travelLicenseImageUrl })}
            />
          ) : (
            "無"
          )}
        </div>
        <div>
          <span className="text-m font-bold">車輛鑑定書：</span>
          {props.car?.appraisalImageUrl ? (
            <Button
              type="primary"
              shape="circle"
              icon={<FileImageOutlined />}
              onClick={() => showModalImage({ title: "車輛鑑定書", url: props.car?.appraisalImageUrl })}
            />
          ) : (
            "無"
          )}
        </div>
        <div>
          <span className="text-m font-bold">賣家資訊：</span>
          {props.car?.customerName} / {props.car?.customerPhone}
        </div>
      </Col>
    </Row>
  );
}

type CarImageProps = { id: number; isCover: boolean; url: string };
type CustomSliderProps = {
  images: CarImageProps[];
};

const CustomSlider = (props: CustomSliderProps) => {
  const settings = useMemo(
    () => ({
      customPaging: (index: number) => (
        <div>
          <Image src={props.images[index].url} preview={false} alt="car-item" />
        </div>
      ),
      dots: true,
      dotsClass: "slick-dots slick-thumb",
      infinite: (props.images || []).length > 1 ? true : false,
      // speed: 500,
      // slidesToShow: 1,
      // slidesToScroll: 1,
    }),
    [props.images]
  );

  return (
    <div className="slider-container">
      <Slider {...settings}>
        {props.images.map((item, index) => (
          <div key={item.id}>
            <Image src={item.url} alt="car-item" />
          </div>
        ))}
      </Slider>
    </div>
  );
};
